import GreetingSection from 'components/navbar/GreetingSection';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Select, Row, Col, Divider, Button, Grid } from 'antd';
import { usePolicyDropDown, useLifeBeneficiaryInfo } from 'all-in-one-shared-api';
import { useEffect, useState, Fragment } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { useLocation, useNavigate } from 'react-router-dom';
import { PolicyDropDown } from 'all-in-one-shared-api/dist/apis/policy/usePolicyDropDown';
import { beneficiaryInfo } from 'all-in-one-shared-api/dist/apis/benefits/useLifeBeneficiaryInfo';
import { isLocaleEnglish } from 'utils/languageUtils';
import KnowMoreArrowIcon from 'assets/images/home/chevron-right-red.svg';
import { Spinner } from 'components';
import IrrevocableIcon from 'assets/images/policy/Irrevocable.svg';

import './viewBeneficiaries.less';
const { Option } = Select;
const ViewBeneficiariesContainer = styled.div`
  margin: 0;
`;
const { useBreakpoint } = Grid;
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
interface LocationState {
  policyNumber: string;
  companyCode: string;
}
const StyledBlock = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 640px;
  margin: 0 auto;
  background: #fff;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 20px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const FlexCol = styled(Col)<{ flag?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${(props) => (props.flag ? '0 16px' : '0')};
`;
const KnowMoreLinkImage = styled.img`
  margin-left: 12px;
  width: 14px;
  height: 8px;
`;
export default function ViewBeneficiaries() {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const location = useLocation();
  const { token } = useKeycloakReady();
  const { policyNumber: policyNo, companyCode: companyNo } = (location.state as LocationState) ?? {};
  const [policyNumber, setPolicyNumber] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [selectItem, setSelectItem] = useState<PolicyDropDown>();
  const [randoms, setRandoms] = useState(Math.random());
  const [primaryData, setPrimaryData] = useState<beneficiaryInfo>([]);
  const [secondary, setSecondary] = useState<beneficiaryInfo>([]);
  const navigate = useNavigate();
  const { lg } = useBreakpoint();
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const { shouldFetch, data } = useLifeBeneficiaryInfo(
    'useLifeBeneficiaryInfo' + randoms,
    token ?? '',
    policyNumber,
    companyCode,
    {
      onSuccess: () => {
        setStartLoading(false);
      },
      onError: () => {
        setStartLoading(false);
      },
    },
  );
  const { shouldFetch: shouldFecthDrop, data: dropData } = usePolicyDropDown('usePolicyDropDown', token ?? '');
  const changeOptions = (value: string) => {
    console.log(value);
    setPolicyNumber(value);
    setSelectItem(dropData?.filter((item) => item.policyNumber === value)[0]);
    if (selectItem) setCompanyCode(selectItem.companyCode);
  };
  useEffect(() => {
    setStartLoading(true);
    if (!dropData) return;
    console.log(dropData, 'dropData');
    if (policyNo && companyNo) {
      console.log('监听policyNo');
      setPolicyNumber(policyNo);
      setCompanyCode(companyNo);
    }
  }, [policyNo, companyNo, dropData]);
  useEffect(() => {
    if (!data) return;
    console.log('data--------------------------', data);
    shouldFetch(false);
    const primaryData = data.filter((item) => item.roleDesc === 'Primary Beneficiary');
    const secondary = data.filter((item) => item.roleDesc === 'Secondary Beneficiary');
    setPrimaryData(primaryData ?? []);
    setSecondary(secondary ?? []);
  }, [data, shouldFetch, primaryData, secondary]);
  useEffect(() => {
    if (policyNumber && companyCode) {
      console.log('监听policyNumber');
      setRandoms(Math.random());
      shouldFetch(true);
    }
    shouldFecthDrop(true);
  }, [policyNumber, companyCode, shouldFecthDrop, shouldFetch]);
  const DividerLine = ({ padB }: DividerLineProps) => {
    return (
      <Androw justify="start" padB={padB}>
        <AndCol style={{ width: '100%' }}>
          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
        </AndCol>
      </Androw>
    );
  };
  const toDownload = () => {
    navigate('/MakeRequestPage', {
      state: {
        tabs: 0,
      },
    });
  };
  return (
    <ViewBeneficiariesContainer className="view-beneficiaries">
      <GreetingSection pageName={t('life.policies.ChangeBeneficiaries')} showicon={false} />
      <div style={{ position: 'relative' }}>
        {startLoading && (
          <div
            style={{
              width: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              zIndex: 999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner />
          </div>
        )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            top: lg ? '-18px' : '-12px',
            position: 'relative',
          }}
        >
          <Select
            onChange={changeOptions}
            className="policySelect"
            defaultValue={policyNo}
            popupClassName="slectop"
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              width: '640px',
            }}
          >
            {dropData?.map((item) => (
              <Option
                value={item.policyNumber}
                key={item.policyNumber}
                label={isEnglish ? item.productName : item.productNameTC}
              >
                <div style={{ display: 'grid' }}>
                  <span className="black-font">{isEnglish ? item.productName : item.productNameTC}</span>
                  <span className="grey-font">
                    {t('life.policies.policyNo')}
                    {item.policyNumber}
                  </span>
                </div>
              </Option>
            ))}
          </Select>
        </div>
        <StyledBlock className="account-detail">
          <Androw justify="start" paddingFlag="16px">
            <AndCol className="font-size26 grey-font">{t('life.policies.appointment')}</AndCol>
            <AntDivider style={{ margin: '12px 0' }}></AntDivider>
          </Androw>
          {policyNumber && (
            <>
              <Androw justify="space-between" className="pointer">
                <AndCol span={22}>
                  <Androw justify="start">
                    <FlexCol>
                      <span className="font-size20" style={{ marginLeft: '12px' }}>
                        {(primaryData?.length == 0 && secondary?.length == 0) ||
                        (primaryData?.length == 1 && primaryData[0].relationship == 'ES') ||
                        (secondary?.length == 1 && secondary[0].relationship == 'ES')
                          ? t('life.policies.noBeneficiaries')
                          : t('life.policies.hasnoBeneficiaries')}
                      </span>
                    </FlexCol>
                  </Androw>
                </AndCol>
                {!(
                  (primaryData?.length == 0 && secondary?.length == 0) ||
                  (primaryData?.length == 1 && primaryData[0].relationship == 'ES') ||
                  (secondary?.length == 1 && secondary[0].relationship == 'ES')
                ) && (
                  <AndCol>
                    <Androw justify="start">
                      <FlexCol>
                        <span className="font-size17 grey-font" style={{ marginLeft: '12px' }}>
                          {t('life.policies.hasBenefitDes')}
                        </span>
                      </FlexCol>
                    </Androw>
                  </AndCol>
                )}
                {((primaryData?.length == 1 && primaryData[0].relationship == 'ES') ||
                  (secondary?.length == 1 && secondary[0].relationship == 'ES')) && (
                  <AntDivider style={{ margin: '5px 0 0' }}></AntDivider>
                )}
              </Androw>
              {!(primaryData?.length == 1 && primaryData[0].relationship == 'ES') && (
                <div className="beneficiaries-content">
                  <Androw justify="start">
                    <AntDivider style={{ margin: '12px 0' }}></AntDivider>
                  </Androw>
                  {primaryData && primaryData.length > 0 && (
                    <>
                      <Androw justify="start">
                        <AndCol>
                          <div className="tagging">
                            <span className="font-size17 font-setting500 grey-font">
                              {t('life.policies.Primarybeneficiaries')}
                            </span>
                          </div>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      <Androw justify="start">
                        <AndCol style={{ width: '100%' }}>
                          <Androw justify="start">
                            <Col lg={19} md={19} sm={15} xs={15}>
                              <div className="tagging">
                                <span className="font-size17 font-setting500"> {t('life.beneficiaries.name')}</span>
                                <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                              </div>
                            </Col>
                            <Col span={1}>
                              <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                            </Col>
                            <Col lg={4} md={4} sm={7} xs={7}>
                              <div
                                className="tagging"
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  marginLeft: '0',
                                  padding: isEnglish ? '0' : '0 30px',
                                }}
                              >
                                <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                  {t('life.policies.ShareAllocation')}
                                </span>
                              </div>
                            </Col>
                          </Androw>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      {primaryData?.map((beneficiary, index) => {
                        return (
                          <Fragment key={index}>
                            <Androw justify="start">
                              <AndCol style={{ width: '100%' }}>
                                <Androw justify="start">
                                  <Col
                                    lg={19}
                                    md={19}
                                    sm={15}
                                    xs={15}
                                    style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                  >
                                    {beneficiary.irrevocableFlag && <img src={IrrevocableIcon} alt="" />}
                                    <div
                                      className={`tagging tagging-special ${beneficiary.irrevocableFlag ? 'mg-l' : ''}`}
                                    >
                                      <span className="font-size17 font-setting500">
                                        {beneficiary.givenName + ' ' + beneficiary.surname}
                                      </span>
                                      <span className="font-size17 grey-font">
                                        {isEnglish ? beneficiary.relationshipDesc : beneficiary.relationshipDescTc}
                                      </span>
                                    </div>
                                  </Col>
                                  <Col span={1}>
                                    <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                  </Col>
                                  <Col lg={4} md={4} sm={7} xs={7}>
                                    <div
                                      className="tagging"
                                      style={{
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        marginLeft: '0',
                                      }}
                                    >
                                      <span className="font-size20" style={{ textAlign: 'center' }}>
                                        {beneficiary.share == 'Equal Share'
                                          ? isEnglish
                                            ? beneficiary.share
                                            : '平均分配'
                                          : beneficiary.share}
                                      </span>
                                    </div>
                                  </Col>
                                </Androw>
                              </AndCol>
                            </Androw>
                            <DividerLine></DividerLine>
                          </Fragment>
                        );
                      })}
                      <Androw justify="center" align="middle" style={{ height: '60px' }}>
                        <AndCol>
                          <span style={{ fontWeight: 'normal', fontSize: 18 }}>{t('life.policies.Totalshares')}</span>
                        </AndCol>
                      </Androw>
                      {primaryData.some((item) => item.irrevocableFlag) && (
                        <>
                          <DividerLine></DividerLine>
                          <Androw justify="start" style={{ paddingBottom: '26px' }}>
                            <AndCol style={{ marginRight: '9px' }}>
                              <img src={IrrevocableIcon} alt="" />
                            </AndCol>
                            <Col>
                              <span className="font-size17 grey-font">{t('life.policies.Irrevocable')}</span>
                            </Col>
                          </Androw>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
              {!(secondary?.length == 1 && secondary[0].relationship == 'ES') && (
                <>
                  {secondary && secondary.length > 0 && (
                    <div className="beneficiaries-content" style={{ marginTop: '24px' }}>
                      <Androw justify="start" style={{ paddingTop: '26px' }}>
                        {/* <AntDivider style={{ margin: '12px 0' }}></AntDivider> */}
                        <AndCol>
                          <div className="tagging">
                            <span className="font-size17 font-setting500 grey-font">
                              {t('life.policies.SecondaryTitle')}
                            </span>
                          </div>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      <Androw justify="start">
                        <AndCol style={{ width: '100%' }}>
                          <Androw justify="start">
                            <Col lg={19} md={19} sm={15} xs={15}>
                              <div className="tagging">
                                <span className="font-size17 font-setting500">{t('life.beneficiaries.name')}</span>
                                <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                              </div>
                            </Col>
                            <Col span={1}>
                              <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                            </Col>
                            <Col lg={4} md={4} sm={7} xs={7}>
                              <div
                                className="tagging"
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  marginLeft: '0',
                                  padding: isEnglish ? '0' : '0 30px',
                                }}
                              >
                                <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                  {t('life.policies.ShareAllocation')}
                                </span>
                              </div>
                            </Col>
                          </Androw>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      {secondary?.map((beneficiary, index) => {
                        return (
                          <Fragment key={index}>
                            <Androw justify="start">
                              <AndCol style={{ width: '100%' }}>
                                <Androw justify="start">
                                  <Col lg={19} md={19} sm={15} xs={15}>
                                    <div className="tagging">
                                      <span className="font-size17 font-setting500">
                                        {beneficiary.givenName + ' ' + beneficiary.surname}
                                      </span>
                                      <span className="font-size17 grey-font">
                                        {isEnglish ? beneficiary.relationshipDesc : beneficiary.relationshipDescTc}
                                      </span>
                                    </div>
                                  </Col>
                                  <Col span={1}>
                                    <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                  </Col>
                                  <Col lg={4} md={4} sm={7} xs={7}>
                                    <div
                                      className="tagging"
                                      style={{
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        marginLeft: '0',
                                      }}
                                    >
                                      <span className="font-size20" style={{ textAlign: 'center' }}>
                                        {beneficiary.share == 'Equal Share'
                                          ? isEnglish
                                            ? beneficiary.share
                                            : '平均分配'
                                          : beneficiary.share}
                                      </span>
                                    </div>
                                  </Col>
                                </Androw>
                              </AndCol>
                            </Androw>
                            <DividerLine></DividerLine>
                          </Fragment>
                        );
                      })}
                      <Androw justify="start" style={{ paddingTop: '60px' }}>
                        <AndCol style={{ width: '100%' }}>
                          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
                        </AndCol>
                      </Androw>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <Androw justify="start" paddingFlag="16px">
            <AndCol className="font-size26 grey-font">
              <div className="tagging">
                <span className="font-size17 font-setting500">{t('life.policies.beneficiariesDesc')}</span>
              </div>
            </AndCol>
          </Androw>
          <Androw style={{ height: '84px', paddingBottom: '24px' }}>
            <Androw justify="center" align="middle">
              <AndCol>
                <Button type="text" block size="large" onClick={toDownload}>
                  <span className="font-setting500 font-size17 red-font">{t('life.policies.downloadForm')}</span>
                  <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
                </Button>
              </AndCol>
            </Androw>
          </Androw>
        </StyledBlock>
      </div>
    </ViewBeneficiariesContainer>
  );
}
